import styles from './AddEventUser.module.css';
import { useAppSelector, useAppDispatch } from '../../app/hooks';
import { Page } from "../../Page"
import '../../App.css';
import { useAuth0 } from "@auth0/auth0-react"
import { selectCurrentPartyEvent } from '../currentPartyEvent/currentPartyEventSlice'
import { useEffect } from 'react';
import { resetButtons, setBackButtonVisible, setSaveEventUserVisible, setPromptOkCancelOnBack } from '../menu/menuSlice'
import { selectCurrentEventUserAlias, selectCurrentEventUserEmail, setAlias, setUserEmail, selectCurrentEventUserStatus, addEventUserAsync } from './currentEventUserSlice'
import { MessageBoxAction, setMessage, setMessageBoxAction } from '../messageBoxes/messageBoxSlice';
import { useNavigate } from 'react-router-dom';
import { addInvitationAsync } from '../invitation/invitationSlice';
import { transmissionDateToDisplayableDateTime } from '../../utils/dateUtils';
import { BackButton } from '../menu/BackButton';


export function EditEventUser() {
    const currentPartyEvent = useAppSelector(selectCurrentPartyEvent)
    const dispatch = useAppDispatch()
    const alias = useAppSelector(selectCurrentEventUserAlias)
    const userEmail = useAppSelector(selectCurrentEventUserEmail)
    const currentEventUserStatus = useAppSelector(selectCurrentEventUserStatus)
    const { isAuthenticated, getAccessTokenSilently, user } = useAuth0()
    const navigate = useNavigate()

    useEffect(() => {
        dispatch(resetButtons())
        dispatch(setBackButtonVisible(true))
        dispatch(setSaveEventUserVisible(true))
        dispatch(setPromptOkCancelOnBack(false))
        dispatch(setMessage('Are you sure you want to cancel saving this party?'))
    }, [dispatch])
    return (
        <Page>
            <div className={styles.bannerContainer}>
                <div>
                <h2>PartyPlanner.</h2>
                <h4>Organise, invite and celebrate in style.</h4>
                </div>
                    <BackButton/>
            </div>
            <div className={styles.currentEventInfoPanel}>
                    <h1>{currentPartyEvent?.title}</h1>
                    <div className='titleSubInfoPanel'>
                        <p>{currentPartyEvent?.location}</p>
                        <p>{currentPartyEvent?.start ? transmissionDateToDisplayableDateTime(currentPartyEvent.start): 'No Start Time'}</p>
                    </div>
                </div>
                    <h3>Add your details below to be in this event:</h3>
                <div className={styles.detailsContainer}>
                    <h4>*Email cannot be changed*</h4>

                    <h4 id={styles.titlePanel}> Name:</h4>
                    <input
                        size={22}
                        id='txtAlias'
                        className={styles.textbox}
                        aria-label="Set Alias"
                        value = {alias}
                        onChange={(e) => dispatch(setAlias(e.target.value))}/>
                    <h4 id={styles.titlePanel}> Email:</h4>
                    <input
                        size={22}
                        id='txtUserEmail'
                        className={styles.textbox}
                        aria-label="Set Email"
                        value = {userEmail}
                        onChange={(e) => dispatch(setUserEmail(e.target.value))}
                        disabled = {true}/>
                </div>
                <br></br>
                <div className={styles.SaveCancelButtons}>
                <button className={styles.cancelButton} onClick={()=> {
                    let msg4 = `Are you sure you want to cancel adding this person?`
                    dispatch(setMessage(msg4))
                    dispatch(setMessageBoxAction(MessageBoxAction.GoBack))
                    navigate('/MessageBox')
                }}> Cancel</button> 

                <button className={styles.SaveButton} onClick={async () => {
                            if (isAuthenticated && user?.email) { 
                                
                                const accessToken = await getAccessTokenSilently({ authorizationParams : {
                                }})
                                    dispatch(addEventUserAsync( { 
                                        token: accessToken
                                        }))
                                    if (currentEventUserStatus === 'idle') {
                                        dispatch (addInvitationAsync(
                                            {
                                                token: accessToken
                                            }
                                        ))
                                        if (currentEventUserStatus === 'idle') {

                                            navigate(-1)
                                        }
                                    } else {
                                        alert (`Not expected status '${ currentEventUserStatus }'`)
                                    }
                            }
                        }}>
                            Save
                        </button>
                    </div>
        </Page>
    )
}